export const SET_CHANGEPASSWORD_STATUS = 'changePassword/SET_CHANGEPASSWORD_STATUS';
export const CHANGE_PASSWORD = 'changePassword/CHANGE_PASSWORD';
